import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import BonusProductList from './BonusProductList';
import UserBonusProductList from './UserBonusProductList';
import Page404 from '../../components/Page404';
import BonusProduct from './BonusProduct';
import RecommendProductList from './RecommendProductList';
import BonusProductQRCodeList from './BonusProductQRCodeList';
import LinkBonusProductQRCode from './LinkBonusProductQRCode';
import UseBonusProductQRCode from './UseBonusProductQRCode';
import BonusProductQRCodeGroupList from './BonusProductQRCodeGroupList';
import GroupBonusProductQRCode from './GroupBonusProductQRCode';

const BonusProductRoute = () => {
  const { url } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`/BonusProduct/Create`} component={BonusProduct} />
      <Route
        path={`${url}/RecommendProductList`}
        component={RecommendProductList}
      />
      <Route path={`${url}/BonusProductList`} component={BonusProductList} />
      <Route
        path={`${url}/UserBonusProductList`}
        component={UserBonusProductList}
      />
      <Route
        path={`${url}/BonusProductQRCodeList`}
        component={BonusProductQRCodeList}
      />
      <Route
        path={`${url}/BonusProductQRCodeGroupList`}
        component={BonusProductQRCodeGroupList}
      />
      <Route
        path={`${url}/LinkBonusProductQRCode`}
        component={LinkBonusProductQRCode}
      />
      <Route
        path={`${url}/UseBonusProductQRCode`}
        component={UseBonusProductQRCode}
      />
      <Route
        path={`${url}/GroupBonusProductQRCode`}
        component={GroupBonusProductQRCode}
      />
      <Route path={`/BonusProduct/:id`} component={BonusProduct} />
      <Route component={Page404} />
    </Switch>
  );
};

export default BonusProductRoute;
